import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `GrupoVerraco`, method: 'GET', body: null, token: token})
}
